<!--
  系统维护中
  lovi 2020-3-19
-->
<template>
  <div class="maintain">
    <template v-if="maintainFlag">
      <img class="pic" :src="httpUrl + maintainData" />
      <h3>{{ maintainData.content }}</h3>
      <a :href="serviceLink" target="_blank" class="button">
        {{ $t("withdraw.onlineServiceCustomer") }}
      </a>
    </template>
  </div>
</template>

<script>
export default {
  name: "maintain",
  meta: {
    head: false,
    power: false
  },
  data() {
    return {
      maintainFlag: false,
      maintainData: {},
      serviceLink: ""
    };
  },
  created() {
    this.getHomeData();
    this.customerAddr();
  },
  mounted() {},
  computed: {},
  methods: {
    getHomeData() {
      let vm = this;
      clearTimeout(vm.timer);
      vm.$post("/app/index/index", {}, { alert: true })
        .then(res => {
          console.log("index", res);
          if (res.code == 0) {
            vm.$router.push({
              path: "/recharge/single"
            });
          }
          if (res.code == 10000) {
            vm.maintainFlag = true;
            vm.maintainData = res.data;
            vm.timer = setTimeout(() => {
              vm.getHomeData();
            }, 3000);
          }
        })
        .catch(error => {
          // 错误信息
          console.log("接口錯誤信息", error);
          vm.timer = setTimeout(() => {
            vm.getHomeData();
          }, 3000);
        });
    },
    customerAddr() {
      let vm = this;
      vm.$post("/app/index/customerAddr", {}, { loading: true }).then(res => {
        console.log("customerAddr", res);
        vm.serviceLink = res.customer_service_link;
      });
    }
  },
  watch: {},
  components: {},
  beforeDestroy() {
    clearTimeout(this.timer);
  }
};
</script>

<style lang="less" scoped>
.maintain {
  text-align: center;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  flex-flow: column;
  .pic {
    margin: 0 auto;
    max-width: 500px;
  }
  h3 {
    padding: 20px 0;
    font-weight: 20px;
    font-weight: 400;
    line-height: 1;
  }
  .button {
    margin: 0 auto;
    display: inline-block;
    width: 250px;
    height: 45px;
    line-height: 45px;
    font-size: 20px;
    color: #fff;
    background: linear-gradient(
      90deg,
      rgba(32, 67, 172, 1) 0%,
      rgba(19, 15, 115, 1) 100%
    );
    border: 0;
    border-radius: 4px;
  }
}
</style>
